/* eslint-disable no-console */
/* tslint:disable */

import * as util from "./util";
import { Glue42Core } from "@glue42/core";

export class LogLevel {
  public static Trace = "trace";
  public static Debug = "debug";
  public static Info = "info";
  public static Warn = "warn";
  public static Error = "error";
}

export class Logger {

  public static Level: string = LogLevel.Info;
  public static GlueLogger: Glue42Core.Logger.API;

  private _glueLogger: Glue42Core.Logger.API;

  public static GetNamed(name: string): Logger {
    return new Logger(name);
  }

  public static Get(owner: any): Logger {
    return new Logger(Logger.GetTypeName(owner));
  }

  public _name: string;

  constructor(name: string) {
    this._name = name;
    // we have a glue logger let's create a new logger for it
    if (!util.isUndefinedOrNull(Logger.GlueLogger)) {
      this._glueLogger = Logger.GlueLogger.subLogger(name);
    }
  }

  public trace(message: string) {
    if (!util.isUndefinedOrNull(this._glueLogger)) {
      this._glueLogger.trace(message);
    } else {
      if (Logger.Level === LogLevel.Trace) {
        console.info(this._getMessage(message, LogLevel.Trace));
      }
    }
  }

  public debug(message: string) {
    if (!util.isUndefinedOrNull(this._glueLogger)) {
      this._glueLogger.debug(message);
    } else {
      if (Logger.Level === LogLevel.Debug ||
        Logger.Level === LogLevel.Trace) {
        console.info(this._getMessage(message, LogLevel.Debug));
      }
    }
  }

  public info(message: string) {
    if (!util.isUndefinedOrNull(this._glueLogger)) {
      this._glueLogger.info(message);
    } else {
      if (Logger.Level === LogLevel.Debug ||
        Logger.Level === LogLevel.Trace ||
        Logger.Level === LogLevel.Info) {
        console.info(this._getMessage(message, LogLevel.Info));
      }
    }
  }

  public warn(message: string) {
    if (!util.isUndefinedOrNull(this._glueLogger)) {
      this._glueLogger.warn(message);
    } else {
      if (Logger.Level === LogLevel.Debug ||
        Logger.Level === LogLevel.Trace ||
        Logger.Level === LogLevel.Info ||
        Logger.Level === LogLevel.Warn) {
        console.info(this._getMessage(message, LogLevel.Info));
      }
    }
  }

  public error(message: string) {
    if (!util.isUndefinedOrNull(this._glueLogger)) {
      this._glueLogger.error(message);
    } else {
      console.error(this._getMessage(message, LogLevel.Error));
      console.trace();
    }
  }

  public _getMessage(message: string, level: string): string {
    return "[" + level + "] " + this._name + " - " + message;
  }

  /**
   * Returns the function name for a given object (same as constructor.name but cross-browser)
   */
  public static GetTypeName(object: object): string {
    const funcNameRegex = /function (.{1,})\(/;
    const results = (funcNameRegex).exec(object.constructor.toString());
    return (results && results.length > 1) ? results[1] : "";
  }
}
